import { render, staticRenderFns } from "./kjcxMain.vue?vue&type=template&id=fc360298&"
import script from "./kjcxMain.vue?vue&type=script&lang=js&"
export * from "./kjcxMain.vue?vue&type=script&lang=js&"
import style0 from "./kjcxMain.vue?vue&type=style&index=0&id=fc360298&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports